import React, {useRef} from 'react';
import {Button, Space, message} from 'antd';
import {EditOutlined, DeleteOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import SearchTable from '../../components/admin/SearchTable';
import StatusTag from '../../components/admin/StatusTag';
import {useConfirmModal} from '../../components/ConfirmModal';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import api from '../../services/api';

export default function AdminCategoryList() {
    const navigate = useNavigate();
    const tableRef = useRef();
    const {showConfirm, ConfirmModal} = useConfirmModal();

    const handleDelete = async (id) => {
        showConfirm({
            title: 'Excluir Categoria',
            description: 'Tem certeza que deseja excluir esta categoria?',
            type: 'danger',
            confirmText: 'Excluir',
            cancelText: 'Cancelar',
            onConfirm: async () => {
                try {
                    await api.delete(formatPath(ENDPOINTS.ECOMMERCE_CATEGORY_DETAIL, {id}));
                    message.success('Categoria excluída com sucesso');
                    tableRef.current?.refetch();
                } catch (error) {
                    message.error('Erro ao excluir categoria');
                }
            }
        });
    };

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            width: 100,
            render: (isActive) => <StatusTag isActive={isActive} />,
        },
        {
            title: 'Ordenação',
            dataIndex: 'ordering',
            key: 'ordering',
            width: 100,
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<EditOutlined/>}
                        size="small"
                        onClick={() => navigate(formatPath(ROUTES.ADMIN_ECOMMERCE_CATEGORY_EDIT, {id: record.id}))}
                    />
                    <Button
                        danger
                        icon={<DeleteOutlined/>}
                        size="small"
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            ),
        },
    ];

    return (
        <>
            <SearchTable
                ref={tableRef}
                url={ENDPOINTS.ECOMMERCE_CATEGORY_LIST}
                columns={columns}
                title="Gerenciamento de Categorias"
                buttonProps={{
                    onClick: () => navigate(ROUTES.ADMIN_ECOMMERCE_CATEGORY_CREATE),
                    label: 'Nova Categoria',
                }}
            />
            <ConfirmModal />
        </>
    );
}
